<template>
    <div class="shequ">
        <img src="../../assets/katong.jpg" alt="">
        <div class="zhezhao_bai"></div>
        <div class="text">
            <p>皮皮社区</p>
            年轻人的交友社区，一个温馨的角落，分享你的碎语人生，随时随地记录生活点滴！
            <p>敬请期待！</p>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Shequ',
        data() {
            return {
                msg: ''
            }
        },
        beforeDestroy(){
            console.log(this.$store.state.SqHome);//打印出来时undefined
            if(!this.$store.state.SqHome){
                this.$store.commit('changeSqHone',false)
            }
            
        },
    }
</script>
<style scoped lang="scss">
    .shequ{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        img{
            width: 100%;
            height: 100%;
            position: absolute;
            
        }
        .zhezhao_bai{
            width: 100%;
            height: 100vh;
            background-color: rgba(64, 64, 64, 0.3);
            position: absolute;
        }
        .text{
            width: 1085px;
            position: absolute;
            font-size: 29px;
            color: #fff;
            line-height: 50px;
            height: 650px;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            p:nth-child(1){
                font-size: 60px;
                margin-bottom: 35px;
                font-weight: bold;
            }
            p:nth-child(2){
                font-size: 40px;
                margin-top: 200px;
                font-weight: bold;
            }
        }
    }
</style>